import { filtersHelper } from "@/utils";
import { groupModel } from "@/models/api/group.model";
import { locationModel } from "@/models/api/location.model";
import { propertyTypeModel } from "@/models/api/propertyType.model";

export const propertyModel = (data) => ({
  uuid: data.uuid,
  company: data.company,
  companyUUID: data.company_uuid || data.company?.uuid || null,
  registeredOwner: data.registered_owner,
  description: data.description,
  remark: data.remark,
  imageUrl: data.image_url,
  address1: data.address_1,
  address2: data.address_2,
  address3: data.address_3,
  city: data.city,
  state: data.state,
  postcode: data.postcode,
  lat: data.lat,
  lng: data.lng,
  isAsset: data.is_asset,
  isTenanted: data.is_tenanted,
  isMalaysia: data.is_malaysia,
  isPersonal: data.is_personal,
  isActive: data.is_active,
  createdAt: filtersHelper.getDateFormat(data.created_at),
  createdBy: data.created_by,
  updatedAt: filtersHelper.getDateFormat(data.updated_at),
  updatedBy: data.updated_by,
  deletedAt: filtersHelper.getDateFormat(data.deleted_at),
  deletedBy: data.deleted_by,
  group: data.group ? groupModel(data.group) : null,
  location: data.location ? locationModel(data.location) : null,
  propertyType: data.property_type
    ? propertyTypeModel(data.property_type)
    : null,
});
